'use client';

import { environment } from '@/config/environment';
import { useEffect } from 'react';
import { isKnownAutomationClient } from '@/lib/user-agent';

export default function MicrosoftClarity() {
  useEffect(() => {
    const clarityId = environment.analytics.clarityId;

    if (
      !clarityId ||
      !environment.analytics.enabled ||
      isKnownAutomationClient()
    ) {
      return;
    }

    const initClarity = () => {
      (function (
        c: Window & Record<string, unknown>,
        l: Document,
        a: string,
        r: string,
        i: string
      ) {
        c[a] =
          c[a] ||
          function (...args: unknown[]) {
            ((c[a] as { q?: unknown[] }).q =
              (c[a] as { q?: unknown[] }).q || []).push(args);
          };
        const t = l.createElement(r) as HTMLScriptElement;
        t.async = true;
        t.src = 'https://www.clarity.ms/tag/' + i;
        const y = l.getElementsByTagName(r)[0] as HTMLScriptElement;
        y.parentNode?.insertBefore(t, y);
      })(
        window as unknown as Window & Record<string, unknown>,
        document,
        'clarity',
        'script',
        clarityId
      );
    };

    // Load immediately - Clarity is lightweight (~24KB) and needs early loading for performance metrics
    initClarity();
  }, []);

  return null;
}
